export const fondlist = [
  {
    title: 'Save the Children',
    url: 'https://www.savethechildren.net/what-we-do/emergencies/ukraine-crisis',
    img: require('../images/fondsWebp/fonds-x1/1.webp'),
    width: '149px',
    height: '33px',
  },
  {
    title: 'Project HOPE',
    url: 'https://www.projecthope.org/country/ukraine/',
    img: require('../images/fondsWebp/fonds-x1/2.webp'),
    width: '90px',
    height: '45px',
  },
  {
    title: 'UNITED24',
    url: 'https://u24.gov.ua/uk',
    img: require('../images/fondsWebp/fonds-x1/3.webp'),
    width: '149px',
    height: '15px',
  },
  {
    title: 'International Medical Corps',
    url: 'https://internationalmedicalcorps.org/country/ukraine/',
    img: require('../images/fondsWebp/fonds-x1/4.webp'),
    width: '129px',
    height: '35px',
  },
  {
    title: 'Medicins Sans Frontieres',
    url: 'https://www.msf.org/ukraine',
    img: require('../images/fondsWebp/fonds-x1/5.webp'),
    width: '133px',
    height: '47px',
  },
  {
    title: 'RAZOM',
    url: 'https://www.razomforukraine.org/',
    img: require('../images/fondsWebp/fonds-x1/6.webp'),
    width: '105px',
    height: '35px',
  },
  {
    title: 'Action against hunger',
    url: 'https://www.actionagainsthunger.org/location/europe/ukraine/',
    img: require('../images/fondsWebp/fonds-x1/7.webp'),
    width: '78px',
    height: '49px',
  },
  {
    title: 'World vision',
    url: 'https://www.wvi.org/emergencies/ukraine',
    img: require('../images/fondsWebp/fonds-x1/8.webp'),
    width: '81px',
    height: '39px',
  },
  {
    title: 'Serhiy Prytula Charity Foundation',
    url: 'https://prytulafoundation.org/en',
    img: require('../images/fondsWebp/fonds-x1/9.webp'),
    width: '117px',
    height: '39px',
  },
];
